export const Scenes = {
    Preload: "PreloadScene",
    Game: "GameScene",
    Boot: "BootScene",
}